import Reveal from "./Reveal";
import { testimonials } from "@/config/professional";

export default function Testimonials() {
  // Hide the section automatically when there are no real testimonials.
  if (!testimonials || testimonials.length === 0) return null;

  return (
    <section className="bg-secondary-50 py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 md:px-6 lg:px-8">
        <Reveal>
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-primary-600">
            Depoimentos
          </p>
          <h2 className="mt-4 font-heading text-4xl font-semibold leading-[1.1] tracking-tight text-foreground-950 md:text-5xl">
            Histórias de quem recebeu esse cuidado.
          </h2>
        </Reveal>

        <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {testimonials.map((t, i) => (
            <Reveal key={t.name} delay={i * 70}>
              <figure className="flex h-full flex-col justify-between rounded-lg border border-background-200 bg-background-50 p-7">
                <blockquote className="font-heading text-xl leading-relaxed text-foreground-800">
                  “{t.quote}”
                </blockquote>
                <figcaption className="mt-6">
                  <p className="text-sm font-semibold text-foreground-950">
                    {t.name}
                  </p>
                  <p className="mt-1 text-xs text-foreground-500">
                    {t.context}
                  </p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}